import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

class LicensesService {
  getLicenses() {
    return axios.get(API_URL + "/licenses", {
      headers: authHeader(),
    });
  }

  getLicensesById(id) { 
     return axios.get(API_URL + "/licenses/" + id, {
      headers: authHeader(),
    });

  }
}

export default new LicensesService();
